import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: 'Text required in question 4'
 */
export class TextoRequeridoParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Text required in question");
    }

    public traducir(error: string): string {
        const matches = error.match(/\d+/g);
        if (matches == null || matches.length === 0) {
            return "";
        }
        return `La pregunta ${matches[0]} se encuentra vacia`;
    }
}
